import { useMutation } from "react-query";
import axios, { AxiosError } from "axios";
import ReconUpdateRequest from "../request/ReconUpdateRequest";

const UpdateReconEventInstanceApiService = async (request: ReconUpdateRequest): Promise<void> => {
    const url = "/calendar_events/update_instance";
    const { data } = await axios.put(url, request);
    return data;
};


// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useUpdateReconEventInstanceApiService = () =>
    useMutation<void, AxiosError, any>(
        UpdateReconEventInstanceApiService, {
        mutationKey: "UpdateReconEventInstanceApiService"
    }
);

export default useUpdateReconEventInstanceApiService;
